import { render, staticRenderFns } from "./FGompaUserRemoteAutoComplete.vue?vue&type=template&id=28c27278&"
import script from "./FGompaUserRemoteAutoComplete.vue?vue&type=script&lang=ts&"
export * from "./FGompaUserRemoteAutoComplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports